import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '@app/services';
import { OnSaleOffer } from '@interfaces/app';

@Component({
  selector: 'mnf-modal-purchase-part-mkt',
  templateUrl: './modal-purchase-part-mkt.component.html',
  styleUrls: ['./modal-purchase-part-mkt.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalPurchasePartMktComponent {

  partsAmount: number;
  partsValue: number;
  commissionNet: number;
  commissionTax: number;
  total: number;
  devName: string;
  userBalance: number;
  partsSelectedArray: OnSaleOffer[];


  modalOTPConf = {
    header: 'Compra de participaciones',
    title: 'Verificación de compra',
    message: `Ingresa el <span class="cl-primary-7">Token</span> que ha sido enviado ${this.userServ.otpMethod === 'sms' ? 'por SMS' : 'a tu correo electrónico'}`
  };

  constructor(
    private modalRef: MatDialogRef<ModalPurchasePartMktComponent>,
    private userServ: UserService,
  ) { }

  purchaseAction(): void {
    this.modalRef.close(true);
  }

  cancel() {
    this.modalRef.close(false);
  }

}
